"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var isNull = function isNull(value) {
  return value === null;
};

var _default = isNull;
exports.default = _default;